
import { Component, Vue } from 'vue-property-decorator';
import AdyenMerchantPanel from '@/components/smoothrPay/AdyenMerchantPanel.vue';
import { AdyenPlatformComponent } from '@/enums/SmoothrPay';

/** Adyen's transactions overview, per Smoothr Pay merchant. */
@Component({ components: { AdyenMerchantPanel } })
export default class SmoothrPayPayments extends Vue {
  get transactionsOverview(): AdyenPlatformComponent {
    return AdyenPlatformComponent.TRANSACTIONS_OVERVIEW;
  }
}
